document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('stSearchResultsEvent', (event) => {
        setTimeout(() => {
            let productCards = document.querySelectorAll('.st-product-card');
            if (!productCards) return;

            productCards.forEach(productCard => {
                let imageContainer = productCard.querySelector('.st-image-container');
                let extraValue = productCard.querySelector('.st-extra-field-box.st-net');
                let customTags = productCard.querySelector('.st-custom-tags');
                let labels = productCard.querySelector('.st-extra-field-box.st-labels');
                if (imageContainer && extraValue) {
                    imageContainer.appendChild(extraValue);
                }
                if (imageContainer && customTags) {
                    imageContainer.appendChild(customTags);
                }
                if (imageContainer && labels) {
                    imageContainer.appendChild(labels);
                }
            });
        }, 1000);
    });
});
